import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

class VisualImageSlider extends HTMLElement {
  constructor() {
    super();
    this.initSwiper();
  }

  /**
   * Initializes the Swiper instance and sets up event listeners.
   */
  initSwiper() {
    // Check if Swiper exists
    if (typeof Swiper === 'undefined') {
      return;
    }

    // Get swiper element
    this.swiperElement = this.querySelector('.swiper');
    if (!this.swiperElement) {
      console.error('Swiper element not found within visual-image-slider.');
      return;
    }

    // Swiper options
    const swiperOptions = {
      modules: [A11y, Navigation],
      threshold: 10,
      direction: 'horizontal',
      slidesPerView: 1.2,
      centeredSlides: true,
      watchSlidesProgress: true,
      initialSlide: 2,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: this.closest('section').querySelector('.swiper-button-next'),
        prevEl: this.closest('section').querySelector('.swiper-button-prev'),
      },
      on: {
        afterInit: (swiper) => {
          this.handleSlideChange(swiper);
        },
        transitionEnd: (swiper) => {
          this.handleSlideChange(swiper);
        },
      },
    };

    // Init swiper
    this.swiperInstance = new Swiper(this.swiperElement, swiperOptions);

    // Rebuid Swiper in design mode
    if (Shopify.designMode && this.swiperInstance) {
      window.addEventListener('shopify:section:load', () => {
        this.swiperInstance.update();
      });
    }
  }

  /**
   * Handles playing/pausing videos based on the active slide.
   * @param {Swiper} swiper - The swiper instance.
   */
  handleSlideChange(swiper) {
    if (!swiper.slides || swiper.slides.length === 0) return;

    // 1. Pause all videos within the slider
    this.querySelectorAll('.video-slide').forEach((video) => {
      video.pause();
    });

    // 2. Find the active slide
    const activeSlide = this.querySelector('.swiper-slide-active');
    if (!activeSlide) {
      return;
    }

    // 3. Find the video within the active slide
    const videoInActiveSlide = activeSlide.querySelector('.video-slide');
    if (!videoInActiveSlide) {
      return;
    }

    // 4. Check autoplay setting and play if enabled
    const shouldAutoplay = activeSlide.dataset.autoplay === 'true';

    if (shouldAutoplay) {
      videoInActiveSlide.play().catch((error) => {
        console.warn(`Video play prevented for active slide:`, error);
      });
    }
  }
}

customElements.define('visual-image-slider', VisualImageSlider);
